import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import WordCard from '../components/WordCard';
import WordCollections from '../components/WordCollections';
import Subscription from '../components/Subscription';
import DonationBanner from '../components/DonationBanner';
import Footer from '../components/Footer';
import MissingWordCard from '../components/MissingWordCard';
import api from '../services/api';
import './WordEntryPage.css';

const WordEntryPage = () => {
  const { word } = useParams();
  const [state, setState] = useState({
    wordData: null,
    examples: null,
    similarWords: [],
    mnemonics: [],
    error: null,
    isLoading: false
  });

  useEffect(() => {
    if (!word) return;

    const loadWord = async () => {
      setState(prev => ({ ...prev, isLoading: true, error: null }));
      
      try {
        // Fetch all data in parallel
        const [
          data,
          usage,
          similar,
          mnemonicsData
        ] = await Promise.all([
          api.getWord(word),
          api.getUsageExamples(word),
          api.getSimilarWords(word),
          api.getWordMnemonics(word)
        ]);

        // Set all data in a single state update
        setState({
          wordData: data,
          examples: usage,
          similarWords: similar,
          mnemonics: Array.isArray(mnemonicsData.mnemonics) ? mnemonicsData.mnemonics : [],
          error: null,
          isLoading: false
        });
      } catch (err) {
        console.error('Error loading word data:', err);
        setState(prev => ({
          ...prev,
          error: err.message.includes('Word not found') ? err.message : 'Error loading some data',
          wordData: err.message.includes('Word not found') ? null : prev.wordData,
          isLoading: false
        }));
      }
    };

    loadWord();
  }, [word]);

  const { wordData, examples, similarWords, mnemonics, error, isLoading } = state;

  return (
    <div className="word-entry-page">
      <Header />
      <main className="main-content">
        {isLoading ? (
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p className="loading-message">Loading word details...</p>
          </div>
        ) : error ? (
          <section className="missing-word-card-section">
            <MissingWordCard word={word} />
          </section>
        ) : wordData && examples ? (
          <section className="word-card-section">
            <WordCard
              word={wordData.word}
              pronunciation={wordData.ipa}
              pronunciationAudio={wordData.pronunciationAudio}
              partOfSpeech={wordData.partsOfSpeech}
              definition={wordData.quickDefinition}
              example={wordData.quickExample}
              personaExplanation={wordData.explanations}
              examples={examples}
              similarWords={similarWords}
              meanings={wordData.meanings || []}
              mnemonics={mnemonics}
              wordListTags={wordData.wordListTags}
            />
          </section>
        ) : null}

        <section className="word-collections-section">
          <WordCollections />
        </section>

        <section className="subscription-section">
          <Subscription />
        </section>

        <section className="donation-section">
          <DonationBanner />
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default WordEntryPage;
